import { Component } from "@angular/core";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'unit-three-lesson-six-guide',
    templateUrl: './_guide.component.html',
    styleUrls: ['../../_shared/lesson-guides/lesson-guide.component.css']
})
export class UnitThreeLessonSixGuideComponent {

    pageTitle: string = "Lesson Guide | Unit 3, Lesson 6 | T-Folio";
    title: string = "Lesson Guide";
    subtitle: string = "Lesson 6: High School and Beyond Plan";

    public constructor(private titleService: Title) {
        this.titleService.setTitle(this.pageTitle);
    }
}
